import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { firstValueFrom } from "rxjs";
import { AuthService } from "../services/auth/auth.service";

/**
 * Gate for the Classjax-internal /super section. Distinct from "org admin"
 * (a customer role within their own organization). user.is_super is the
 * Classjax-staff flag.
 */
export const superGuard: CanActivateFn = async () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const user = await firstValueFrom(auth.$user);
  if (user?.is_super) return true;

  router.navigate(["/classroom"]);
  return false;
};
